<template>
  <div class="flex filters">
    <search />
    <gender />
    <dateCreated />
    <location />
    <origin v-if="!isTurkish"/>
    <!-- <el-select v-model="filter.gender" placeholder="Gender" class="flex-basis-grow">
      <el-option value="FEMALE" label="Female"></el-option>
      <el-option value="MALE" label="Male"></el-option>
      <el-option value="OTHER" label="Other"></el-option>
    </el-select>
    <el-date-picker v-model="filter.createdDate" type="date" placeholder="Created Date" class="flex-basis-grow"></el-date-picker>
    <el-input v-model="filter.location" placeholder="Location" class="flex-basis-grow"></el-input>
    <el-button type="primary" icon="el-icon-search" style="margin-left: 10px;"></el-button> -->
  </div>
</template>

<script>
import Search from '@/components/Filters/Search/Search'
import Gender from '@/components/Filters/Gender/Gender'
import DateCreated from '@/components/Filters/DateCreated/DateCreated'
import Location from '@/components/Filters/Location/Location'
import Origin from '@/components/Filters/Origin/Origin'
export default {
  name: 'Filters',
  components: {
    Search,
    Gender,
    DateCreated,
    Location,
    Origin
  },
  computed: {
    isTurkish() {
      return this.$store.getters.isTurkish
    }
  }
}
</script>

<style lang="scss">
  @import "~vars";

  .filters {
    margin: ($-padding-unit * 2) 0;
  }
</style>
